import React, { PureComponent } from 'react';
import { CancelToken } from 'axios';
import { Helmet } from 'react-helmet';
import { WidgetMapaPrediccio } from '../../widgets/MapaPrediccio/WidgetMapaPrediccio';
import Loader from '../../partials/Loader/Loader';
import API from '../../utils/api';
import { translate } from '../../utils/translations';
import {
    buildLanguageConfig,
    consoleLogError,
    formatDateUi,
} from '../../utils/utils';
import { parse } from 'qs';
import { WIDGETS_PADDING } from '../../utils/globals';

class MapaPrediccio extends PureComponent {
    state = {
        config: buildLanguageConfig({}),
        data: {},
        days: 0,
        widgetDate: '',
    };

    render() {
        const { data, config, days, widgetDate } = this.state;
        if (config && data) {
            return (
                <div
                    className="MapaPrediccio main-wrapper"
                    style={WIDGETS_PADDING}
                >
                    <Helmet>
                        <title>
                            {translate(config.language, 'prediccio_title')}
                        </title>
                    </Helmet>
                    <WidgetMapaPrediccio
                        data={data}
                        config={config}
                        days={days}
                        preview={this.props.preview}
                        widgetDate={widgetDate}
                    />
                </div>
            );
        } else {
            return <Loader language={config.language} />;
        }
    }

    componentDidMount() {
        this.feedWidget();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props !== prevProps) {
            this.feedWidget();
        }

        const { data } = this.state;

        if (data.map) {
            const days = data.map[2] && data.comarques[2] ? 3 : 2;
            this.setState({ days });
        }
    }

    feedWidget = () => {
        const { location, preview, color, language } = this.props;
        const search = location ? location.search : '';

        let config = {};

        // From Configurador form
        if (preview) {
            config = {
                color,
                language,
            };
        } else {
            // Or from Query String
            config = buildLanguageConfig(
                parse(search, {
                    ignoreQueryPrefix: true,
                })
            );
        }

        const widgetDate = formatDateUi(new Date());
        this.setState({ config, widgetDate });
        this.getData();
    };

    getData = async () => {
        this.cancelTokenSource = CancelToken.source();
        try {
            let data = await API.getCatalunya3(this.cancelTokenSource.token);
            data = {
                map: [data[0].data, data[1].data, data[2].data],
                comarques: [data[3].data, data[4].data, data[5].data],
            };

            if (!data.map[2]) data.map = data.map.slice(0, 2);
            if (!data.comarques[2]) data.comarques = data.comarques.slice(0, 2);

            data.comarques.forEach(comarca => {
                comarca.mati.precipitacio.forEach(precipitacio => {
                    precipitacio.probabilitat = translate(
                        this.state.config.language,
                        `prediccio_rain_prob_${precipitacio.probabilitat}`
                    );
                });
                comarca.tarda.precipitacio.forEach(precipitacio => {
                    precipitacio.probabilitat = translate(
                        this.state.config.language,
                        `prediccio_rain_prob_${precipitacio.probabilitat}`
                    );
                });
            });
            this.setState({ data });
        } catch (e) {
            consoleLogError(e, this.state.config.language);
        }
    };

    componentWillUnmount() {
        this.cancelTokenSource.cancel(
            translate(this.state.config.language, 'cancelled_request')
        );
    }
}

export default MapaPrediccio;



// WEBPACK FOOTER //
// ./src/containers/MapaPrediccio/MapaPrediccio.js